import LayoutPage from "@/views/shared/LayoutPage"

export default [
    {
        path: '/purchase-request/approval',
        component: LayoutPage,
        children: [
            {
                path: "/purchase-request/approval",
                name: "purchase-request-approval",
                component: () => import("@/views/PurchaseRequestApproval.vue"),
                meta: {
                    title: "Purchase Request Approval",
                    titleLocalizationCode: "Purchase_Request_Approval",
                    desc: "Purchase request approval page",
                    descLocalizationCode: "Purchase_Request_Approval_Page",
                    layout:"LayoutPage",
                    sidebarElement: false
                },
            },
        ],
        
    }
]


